var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"forbidden"},[_c('span',{staticClass:"wrapper flex center-all"},[_c('span',{staticClass:"emoji"},[_vm._v("😐")]),_c('p',[_vm._v("You don’t have a permission to do this action.")])]),_c('span',{staticClass:"refresh-me flex center-all"},[_vm._v("\n    Please contact your admin to enable"),_c('br'),_vm._v("this for you.\n  ")])])
}]

export { render, staticRenderFns }